import { prodapiAxiosClient } from "./prodApiClient";

const getReport = (dtStart, dtEnd) => {
  return prodapiAxiosClient
  .get(`/api/v1/statistics/reportRepairCameras/` + dtStart + `/` + dtEnd )
}
///` + '"' + dtStart + '"' + `/` + '"' + dtEnd + '"')
const statisticsApi = {getReport}
export default statisticsApi;